import { useCallback, useState } from 'react'

import {
  AplDocumentTypes,
  downloadAplDocument,
  fetchAplDocumentByParameters,
} from '../../aplUploadForm'
import { TDocumentLanguage } from '../../aplUploadForm/components/uploadForm/models'
import { IAplDocument } from '../../aplUploadForm/models/aplDocument'

export const useAplDocumentDownloadHandler = (language: TDocumentLanguage) => {
  const [isFetchingTCDocument, setIsFetchingTCDocument] = useState(false)
  const [isFetchingSDCDocument, setIsFetchingSDCDocument] = useState(false)
  const [sdcDocument, setSDCDocument] = useState<IAplDocument | null>(null)
  const [tcDocument, setTCDocument] = useState<IAplDocument | null>(null)

  const downloadDocument = useCallback(async (document: IAplDocument | null) => {
    if (document) {
      await downloadAplDocument({
        fileName: document.FileName,
        documentId: document.id,
      })
    }
  }, [])

  const downloadTermsAndConditions = useCallback(async () => {
    setIsFetchingTCDocument(true)
    const item = tcDocument || (await downloadTC(language))
    setTCDocument(item)
    await downloadDocument(item)
    setIsFetchingTCDocument(false)
  }, [downloadDocument, tcDocument, language])

  const downloadSelectiveDistributorCriteria = useCallback(async () => {
    setIsFetchingSDCDocument(true)
    const item = sdcDocument || (await downloadSDC(language))
    setSDCDocument(item)
    await downloadDocument(item)
    setIsFetchingSDCDocument(false)
  }, [downloadDocument, sdcDocument, language])

  const downloadTC = (language: string) => {
    return fetchAplDocumentByParameters({
      languageCode: language,
      type: AplDocumentTypes.TC,
    })
  }

  const downloadSDC = (language: string) => {
    return fetchAplDocumentByParameters({
      languageCode: language,
      type: AplDocumentTypes.SDC,
    })
  }

  return {
    downloadTermsAndConditions,
    downloadSelectiveDistributorCriteria,
    isFetchingSDCDocument,
    isFetchingTCDocument,
  }
}
